import { Component, OnDestroy, OnInit } from '@angular/core';
import { AlertService } from 'app/core/alert.service';
import { animate, keyframes, state, style, transition, trigger } from '@angular/animations';

import { Logger } from 'app/core/index';

const logger = new Logger('alert.component.ts');

@Component({
  selector: 'app-alert',
  templateUrl: './alert.template.html',
  styleUrls: ['./alert.template.scss'],
  animations: [
    trigger('animate', [
      transition(':enter', [
        animate(
          '500ms 0ms cubic-bezier(0.23, 1, 0.32, 1)',
          keyframes([
            style({ opacity: 0, transform: 'translateX(0) translateY(-100%)', offset: 0 }),
            style({ opacity: 1, transform: 'translateX(0) translateY(0)', offset: 1 }),
          ])
        ),
      ]),
      transition(':leave', [
        animate(
          '500ms 0ms cubic-bezier(0.23, 1, 0.32, 1)',
          keyframes([
            style({ opacity: 1, transform: 'translateX(0) translateY(0)', offset: 0 }),
            style({ opacity: 0, transform: 'translateX(0) translateY(-100%)', offset: 1 }),
          ])
        ),
      ]),
    ]),
  ],
})
export class AlertComponent implements OnInit, OnDestroy {
  alerts = null;

  constructor(private alertsService: AlertService) {
    //
  }

  ngOnInit() {
    this.alertsService.alerts$.subscribe((alerts: any) => {
      logger.info(alerts);
      this.alerts = alerts;
    });
  }

  hide(alert: any) {
    this.alertsService.remove(alert);
  }

  ngOnDestroy() {}
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/components/alert/alert.component.ts